<template>
  <line-up
    :match-id="matchId"
    :team-id="teamId"
    :team-type="teamType"
    :actions="actions"
    :data="data"
    :edit="edit"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LineUp from '@/components/management/teams/components/line-up'
export default {
  name: 'TeamLineUp',
  components: { LineUp },
  props: {
    matchId: {
      type: String,
      required: true,
      default: '',
    },
    teamId: {
      type: String,
      required: true,
      default: '',
    },
    teamType: {
      type: String,
      required: true,
      default: 'home',
      validator(val) {
        return ['home', 'visitor'].includes(val)
      },
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapState({
      lineUp: (state) => state.matches.lineUp,
    }),

    actions() {
      return {
        fetchLineUpList: this.fetchLineUpList,
        fetchLineUp: this.fetchLineUp,
        addLineUp: this.addLineUp,
        updateLineUp: this.updateLineUp,
        deleteLineUp: this.deleteLineUp,
        updateFormation: this.updateMatch,
      }
    },
    data() {
      return { ...this.lineUp[this.teamType] }
    },
  },
  methods: {
    ...mapActions({
      fetchLineUpList: 'matches/fetchLineUpList',
      fetchLineUp: 'matches/fetchLineUp',
      addLineUp: 'matches/addLineUp',
      updateLineUp: 'matches/updateLineUp',
      deleteLineUp: 'matches/deleteLineUp',
      updateMatch: 'matches/update',
    }),
  },
}
</script>
